export default "__VITE_ASSET__yB1oImhe__"